import React from 'react';

function DragHandleIcon(props) {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.5 7C9.32843 7 10 6.32843 10 5.5C10 4.67157 9.32843 4 8.5 4C7.67157 4 7 4.67157 7 5.5C7 6.32843 7.67157 7 8.5 7Z"
        fill="#9197a3"
      />
      <path
        d="M15.25 7C16.0784 7 16.75 6.32843 16.75 5.5C16.75 4.67157 16.0784 4 15.25 4C14.4216 4 13.75 4.67157 13.75 5.5C13.75 6.32843 14.4216 7 15.25 7Z"
        fill="#9197a3"
      />
      <path
        d="M8.5 13.375C9.32843 13.375 10 12.7034 10 11.875C10 11.0466 9.32843 10.375 8.5 10.375C7.67157 10.375 7 11.0466 7 11.875C7 12.7034 7.67157 13.375 8.5 13.375Z"
        fill="#9197a3"
      />
      <path
        d="M15.25 13.375C16.0784 13.375 16.75 12.7034 16.75 11.875C16.75 11.0466 16.0784 10.375 15.25 10.375C14.4216 10.375 13.75 11.0466 13.75 11.875C13.75 12.7034 14.4216 13.375 15.25 13.375Z"
        fill="#9197a3"
      />
      <path
        d="M8.5 19.75C9.32843 19.75 10 19.0784 10 18.25C10 17.4216 9.32843 16.75 8.5 16.75C7.67157 16.75 7 17.4216 7 18.25C7 19.0784 7.67157 19.75 8.5 19.75Z"
        fill="#9197a3"
      />
      <path
        d="M15.25 19.75C16.0784 19.75 16.75 19.0784 16.75 18.25C16.75 17.4216 16.0784 16.75 15.25 16.75C14.4216 16.75 13.75 17.4216 13.75 18.25C13.75 19.0784 14.4216 19.75 15.25 19.75Z"
        fill="#9197a3"
      />
    </svg>
  );
}

export default DragHandleIcon;
